// extracted by mini-css-extract-plugin
export var bodySections = "_bl-8";
export var gray = "_bl-7";
export var green = "_bl-4";
export var iconContainer = "_bl-9";
export var iconWidgetContainer = "_bl-1";
export var phoneIcon = "_bl-2";
export var red = "_bl-5";
export var statusDot = "_bl-3";
export var widgetContainer = "_bl-0";
export var yellow = "_bl-6";